import { render } from "@/components/pages/individualWorkSupport/requirement085/Requirement085.html?vue&type=template&id=622be2dc&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement085/Requirement085.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement085/Requirement085.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement085/Requirement085.scss?vue&type=style&index=0&id=622be2dc&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622be2dc"]])

export default __exports__